/**
 * Inline help for the action-module wizard.
 *
 * All help texts live in ONE flat subtree `help.*` of the `action-modules-wizard` namespace.
 * Flat because i18next cannot hold a string and an object under the same key, so a `.help`
 * sibling of an existing label key is impossible without restructuring every label; and always
 * area-prefixed because a flat namespace collides otherwise (`name` exists as both the module
 * name and a subtype name, `start`/`end` in four schedule editors, and so on).
 *
 * Keys are namespace-qualified here so the shared `HelpHint`/`HelpText` components can resolve
 * them without knowing which feature they belong to.
 */
export const helpKey = (id: string) => `action-modules-wizard:help.${id}`
